import { BASE_APP, SERVER_URL } from "../../config";
import vikramshilaLogo from "../../assets/img/logos/vikramshilaLogo.png";
import BannerSvg from "../../assets/img/bg/feedback_banner.png";
import startUpIndia from "../../assets/img/banner/startupIndia.png";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { councilMembers } from "../../utils";
import "../../assets/css/footer.css";
import Twitter from "../../assets/img/icons/twitter-48.png";
import Linkedin from "../../assets/img/icons/linkedin-48.png";
import Facebook from "../../assets/img/icons/facebook-48.png";

const Footer = () => {
  useEffect(() => {
    // $('.menuToggle').click(function () {
    //     $(this).closest('header').find('.navWrap').toggleClass('active');
    //   });
  }, []);

  const navigate = useNavigate();
  const handleRedirect = (e, path = "/registration") => {
    e.preventDefault();
    window.scroll({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  const isCouncil = () => {
    const isCouncilPage =
      councilMembers.indexOf(window.location.pathname) > -1 ||
      window.location.pathname === "/council";
    return isCouncilPage ? "active" : "";
  };

  const isAdvisory = () => {
    const isAdvisoryPage =
      window.location.pathname.match("/member-details") ||
      window.location.pathname === "/advisory";
    return isAdvisoryPage && !isCouncil() ? "active" : "";
  };

  return (
    <footer className="footer">
      <div className="footer-title">
        <div className="containWrap">
          <h2>A HOMEGROWN INDIAN PLATFORM FOR RESEARCH DISSEMINATION</h2>
        </div>
      </div>

      <div className="containWrap">
        <div className="footer-rest">
          <div className="footer-logo">
            <div className="vikramshila-logo">
              <a href={SERVER_URL} onClick={(e) => handleRedirect(e, "/")}>
                <img src={vikramshilaLogo} alt="#" />
              </a>
            </div>
          </div>

          <div className="startup-img">
            <p>Recognized by</p>
            <a href="https://www.startupindia.gov.in/" target="_blank">
              <img src={startUpIndia} alt="#" />
            </a>
          </div>
        </div>

        <div className="footer-part">
            <div className="footer-about">
                <p>
                    Vikramshila is an open access initiative dedicated to advancing
                    equitable, affordable and technology- <br/> enabled dissemination of
                    research. We support <br/> scholars, institutions and educators by
                    providing transparent publishing pathways that amplify voices <br/> from
                    the developing world.
                </p>
                <br/>
                <p>
                    Guided by the values of inclusivity, integrity
                    and community-driven scholarship, Vikramshila works to <br/> help restore
                    India’s legacy as a global centre of <br/> knowledge by making research
                    accessible to all.
                </p>
            </div>
          <div className="footer-content">
                <div>
                <h3>VIKRAMSHILA</h3>
                <ul>
                    <li>
                    <a
                        href="#"
                        onClick={(e) => handleRedirect(e, "/about")}
                        className={
                        window.location.pathname === "/about" ? "active" : ""
                        }
                    >
                        About
                    </a>
                    </li>
                    <li>
                    <a
                        href="#"
                        onClick={(e) => handleRedirect(e, "/teams")}
                        className={
                        window.location.pathname === "/teams" ? "active" : ""
                        }
                    >
                        The Team
                    </a>
                    </li>
                    <li>
                    <a
                        href="#"
                        onClick={(e) => handleRedirect(e, "/advisory")}
                        className={
                        window.location.pathname === "/advisory" ? "active" : ""
                        }
                    >
                        Advisory Board
                    </a>
                    </li>
                    <li>
                    <a
                        href="#"
                        onClick={(e) => handleRedirect(e, "/council")}
                        className={isCouncil()}
                    >
                        Academic Council
                    </a>
                    </li>
                </ul>
                </div>
                <div>
                <h3>PRODUCTS</h3>
                <ul>
                    <li>
                    <a
                        href="#"
                        onClick={(e) =>
                        handleRedirect(e, "/work-in-progress-akashganga")
                        }
                        className={
                        window.location.pathname ===
                        "/work-in-progress-akashganga"
                            ? "active"
                            : ""
                        }
                    >
                        Akashganga
                    </a>
                    </li>
                    <li>
                    <a
                        href="#"
                        
                    >
                        iNextresearcher
                    </a>
                    </li>
                    {/* <li>
                            <a href={`${BASE_APP}/Sevahaat/registration`} className={(window.location.pathname === `${BASE_APP}/Sevahaat/registration`) ? "active" : ''}>Seva Haat</a>
                        </li> */}
                    <li>
                    <a
                        href="/"
                        onClick={(e) => handleRedirect(e, "/contactus")}
                        className={
                        window.location.pathname === "/contactus" ? "active" : ""
                        }
                    >
                        Contact Us
                    </a>
                    </li>
                    <li className="blinkli">
                    <a
                        href="/"
                        onClick={(e) => handleRedirect(e, "/publisharticle")}
                    >
                        Publish Your Article
                    </a>
                    </li>
                </ul>
                </div>
                <div>
                <h3>DISCOVER</h3>
                <ul>
                    <li>
                    <a
                        href="/"
                        onClick={(e) => handleRedirect(e, "/faq")}
                        className={
                        window.location.pathname === "/faq" ? "active" : ""
                        }
                    >
                        FAQs
                    </a>
                    </li>
                    <li>
                    <a
                        href={`${SERVER_URL}/GyanKosh`}
                        className={
                        window.location.pathname === "/GyanKosh" ? "active" : ""
                        }
                    >
                        Blog
                    </a>
                    </li>
                    <li>
                    <a
                        href="/"
                        onClick={(e) => handleRedirect(e, "/playlist")}
                        className={
                        window.location.pathname === "/playlist" ? "active" : ""
                        }
                    >
                        Media Coverage
                    </a>
                    </li>
                    <li>
                    <a
                        href="/"
                        onClick={(e) => handleRedirect(e, "/resourcecentre")}
                        className={
                        window.location.pathname === "/resourcecentre"
                            ? "active"
                            : ""
                        }
                    >
                        Resource Centre
                    </a>
                    </li>
                </ul>
                </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="contactLinks">
            <p>
                <b className="icon-mail"></b>
                <span class="email-text">contactus@vikramshilaedu.in</span>
            </p>

            <p>
              <b>Publisher Name :</b>
              Vikramshila Research Pvt Ltd
              <br />
              I-1667, 3rd Floor, C R Park, New Delhi 110019 India
            </p>
          </div>

          <div className="legalLinks">
            <div>
              <a href="/" onClick={(e) => handleRedirect(e, "/terms")}>
                Terms of Use
              </a>{" "}
              {/* <a href="/" onClick={(e) => handleRedirect(e, '/cookie')}>Cookie Settings</a> */}
              <a href="/" onClick={(e) => handleRedirect(e, "/privacy-policy")}>
                | Privacy Policy
              </a>
            </div>
            <div className="copyRight1">
                ©Vikramshila Research Pvt Ltd 2025. All rights
                reserved.{" "}
            </div>

            {/* <small className="pt-2" style={{ color: 'black' }}>Found a bug in the platform? Please <a className="know-link" href="mailto:contactus@vikramshilaedu.in?subject=Feedback: I found a bug in the platform"><u style={{ color: 'black' }}>click here</u></a></small>
                        <small style={{ color: 'black' }}>Best viewed on Google Chrome for Windows and Safari for MAC</small> */}
          </div>

          <div className="socialLinks">
            <div className="socialLinks-wrap">
              <h3>Follow Us</h3>
              <ul>
                <li>
                  <a
                    href="https://m.facebook.com/100089485867225/"
                    target="_blank"
                  >
                    <img src={Facebook} alt="#" />
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/vikramshila-education-pvt-ltd/"
                    target="_blank"
                  >
                    <img src={Linkedin} alt="#" />
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/VikramshilaL" target="_blank">
                    <img src={Twitter} alt="#" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
